import React from 'react'
import OfferCard from 'home/components/OfferCarousels/common/OfferCard'
import { rem } from 'polished'
import { take } from 'lib/arrayUtils'
import { useOfferList } from 'hooks/Offers/useOfferList'
import ExperienceTileSkeletonLoader from 'components/Experiences/ExperienceTiles/ExperienceTileSkeletonLoader'
import { MAX_CAROUSEL_ITEM_COUNT } from 'home/components/OfferCarousels/common/constants'
import OfferCarouselLookingForSomethingElse from 'home/components/LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import { LFSEOfferType } from 'home/components/LookingForSomethingElse/constants'
import styled from 'styled-components'

const LoadingSkeleton = styled(ExperienceTileSkeletonLoader)`
  width: ${rem(320)};
`

const OFFER_TYPES: App.OfferListOfferType[] = ['hotel', 'tactical_ao_hotel', 'last_minute_hotel']
const DEFAULT_FILTERS: App.OfferListFilters = {
  offerTypes: OFFER_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  sortBy: 'homepage',
}

interface Props {
  hasLFSECarousel: boolean;
  filters?: App.OfferListFilters;
}

function HotelOfferCardItem({ filters, hasLFSECarousel }: Props) {
  const [offerList] = useOfferList(filters ?? DEFAULT_FILTERS)

  if ((offerList.offerIds.length === 0)) {
    return null
  }

  return (
    <>
      {offerList.fetching && (
        <>
          <LoadingSkeleton />
          <LoadingSkeleton />
          <LoadingSkeleton />
          <LoadingSkeleton />
        </>
      )}
      {take(offerList.offerIds, MAX_CAROUSEL_ITEM_COUNT).map((id: string, idx: number) => (
        <OfferCard key={id} id={id} idx={idx} />
      ))}
      {hasLFSECarousel && <OfferCarouselLookingForSomethingElse offerType={filters?.offerTypes?.includes('cruise') ? LFSEOfferType.Cruises : LFSEOfferType.Hotel} />}
    </>
  )
}

HotelOfferCardItem.defaultProps = {
  hasLFSECarousel: true,
}

export default HotelOfferCardItem
